export default __webpack_public_path__ + "static/media/img (1).85c9f9a7.jpg";